<button (click)="toggleModal()" tid="open-payrolls-chat-bot-button">
  <img [src]="isOpen ? '/assets/img/minerva-close.svg' : '/assets/img/minerva-open.svg'" alt="Minerva Icon" />
</button>
